import React from 'react'
import Helmet from 'react-helmet'
import { observer } from 'mobx-react'
import { HeaderSink, HeaderTitle } from 'components/Header'
import ProfileEditor from 'components/ProfileEditor'
import intercomUpdate from 'decorators/intercomUpdate'

@intercomUpdate({ screen: 'Profile' })
@observer
export default class ProfileScreen extends React.Component {
  componentWillMount () {
    this.props.rootStore.profileEditorStore.activate()
  }

  render () {
    return (
      <div className="profile-screen">
        <Helmet title="Profile" />
        <HeaderSink small>
          <HeaderTitle>
            Your Profile
          </HeaderTitle>
        </HeaderSink>

        <div className="container has-spacing-top">
          <div className="columns">
            <div className="column is-8 is-offset-2">
              <ProfileEditor profileEditorStore={this.props.rootStore.profileEditorStore} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/Profile/index.jsx